/** Нормализация соответствует shared/search-term; фронт не импортирует серверный пакет. */
export function normalizeSearchTerm(input: unknown): string {
  return String(input ?? '')
    .replace(/[\u0000-\u001f\u007f-\u009f]/g, (character) => /\s/.test(character) ? character : '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100)
    .trimEnd()
}
